// extracted by mini-css-extract-plugin
export default {"caseContent":"styles_caseContent__Bgi-9"};